module.exports = __webpack_public_path__ + "static/media/rounded.70d84b8b.jpg";